import Slider from "react-slick";
import { TestimonialOneParams } from "../../utils/script";
import SectionTitle from "../sectionTitle/SectionTitle";

let data = [
  {
    name: "Asyiqin Faatina",
    details:
      "As my on-job training journey with Energy Commission of Sabah comes to an end, I want to take a moment to express my deepest gratitude. \nThese past months have been such an eye-opening and rewarding experience. From learning about Integrity, governance, compliance, and sustainability to joining various programs and initiatives, every moment has helped me grow both personally and professionally.",
    designation: "Energy Commission of Sabah ",
    image: "testi-1.png",
  },
  {
    name: "Alisa Zarina",
    details:
      "During my time at Group IT, I took on multiple roles — from System Developer to QA/Software Tester and Data Analyst — each teaching me about how technology, data and teamwork come together to drive business results. \nThese experiences strengthened my technical foundation and adaptability — balancing system troubleshooting, data analysis and stakeholder coordination — while reinforcing my passion for data-driven solutions and digital transformation.",
    designation: "Media Prima Berhad",
    image: "testi-2.png",
  },
  {
    name: "Redza Buhary",
    details:
      "I was placed at SUNCROX SOLAR, a company focused on solar energy and sustainability, under the Digital Marketing team. Through this program, I learned to adapt to real-world challenges, sharpened my creativity, and built stronger communication and teamwork skills.\nThe training modules were also incredibly valuable from personal branding to ESG awareness helping me understand both the technical and professional sides of the industry.",
    designation: "Suncrox Solar",
    image: "testi-3.png",
  },
  {
    name: "Fikri Mahdhir",
    details:
      "When I first applied for the K-Youth Development Program (by Khazanah Nasional & Pepper Labs), I wasn’t sure what to expect. Would it really help me gain skills? Would it open doors? I was offered a QA Engineer Trainee role. Truthfully, I always thought I wanted to be a developer. But being unemployed for four months after internship ended, I knew I couldn’t let this chance pass. So I gave it a try — and looking back, I’m glad I did.\nThe training modules were also surprisingly practical. They started with the basics and moved toward industry-focused skills, complete with certifications. The Personal Branding & Resume Writing module especially helped me sharpen how I present myself. Balancing modules while working taught me valuable time management too.",
    designation: "Pos Malaysia",
    image: "testi-4.png",
  },
  {
    name: "Nurul Syahira",
    details:
      "Throughout this programme, I had the opportunity to enhance my professional skills, gain valuable industry exposure, and broaden my understanding of workplace expectations. \nThis experience has been instrumental in strengthening my confidence and preparing me for the next stage of my career journey. I'm really grateful for all the guidance and support I've gotten during this programme from all the wonderful people who helped me along the way. and of course, definitely going to miss my friends who made this journey so meaningful",
    designation: "MBSB Berhad",
    image: "testi-5.png",
  },
  {
    name: "Shelina Winthya",
    details:
      "As I close the chapter of mine as a Digital Communication Associate at Pepper Labs, looking back at how much I’ve grown through this journey, both personally and professionally.\nA huge thank you to the mentors. And to my teammates who guided, supported and believed in me throughout this 4-month journey, I wouldn't have done it without your motivation to keep me going. ",
    designation: "Pepper Labs Sdn. Bhd.",
    image: "testi-6.png",
  },
];

const KYouthTestimonialFour = () => {
  const classes = `testimonial-activation testimonial-style-1 edu-slick-button slick-button-left`;
  data = 6 ? data.slice(0, 6) : data;
  return (
    <div className="eduvibe-testimonial-one edu-testimonial-area edu-section-gap bg-image">
      <div className="container eduvibe-animated-shape">
        <div className="row">
          <div className="col-lg-12">
            <SectionTitle
              classes="text-center"
              slogan="Testimonial"
              title="Our K-Youth 2025 Testimonials"
            />
          </div>
        </div>
        <div className="row g-5 mt--25">
          <div
            className="col-12"
            style={{ backgroundColor: "#fff", borderRadius: 30, padding: 50 }}
          >
            <Slider className={classes} {...TestimonialOneParams}>
              {data.map((item, i) => {
                const splitDetails = item.details.split("\n");
                return (
                  <div key={i} className="single-testimonial">
                    <div
                      className="inner"
                      style={{ display: "flex", flexWrap: "wrap" }}
                    >
                      <div className="col-lg-8 col-12">
                        <div className="quote-sign">
                          <img
                            src="/k-youth/images/testimonial/testimonial-01/quote.png"
                            alt="Quote Images"
                          />
                        </div>
                        <p
                          className="description"
                          style={{ textAlign: "justify" }}
                        >
                          “
                          {splitDetails.map((detail, index) => (
                            <span>
                              {detail}
                              {splitDetails.length !== index + 1 && (
                                <>
                                  <br />
                                  <br />
                                </>
                              )}
                            </span>
                          ))}
                          ”
                        </p>
                        <div className="client-information">
                          <div className="info">
                            <h5 className="title">{item.name}</h5>
                            <span className="designation">
                              {item.designation}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div
                        className="thumb col-lg-4 col-12"
                        style={{
                          marginTop: "auto",
                          marginBottom: "auto",
                        }}
                      >
                        <img
                          style={{
                            padding: 30,
                            paddingRight: 30,
                            borderRadius: 1000,
                          }}
                          src={`${process.env.PUBLIC_URL}/k-youth/assets/${item.image}`}
                          alt="Client Thumb"
                        />
                      </div>
                    </div>
                  </div>
                );
              })}
            </Slider>
          </div>
        </div>

        <div className="shape-dot-wrapper shape-wrapper d-xl-block d-none">
          <div className="shape-image shape-image-1">
            <img src="/k-youth/images/shapes/shape-13.png" alt="Shape Thumb" />
          </div>
          <div className="shape-image shape-image-2">
            <img
              src="/k-youth/images/shapes/shape-13-01.png"
              alt="Shape Thumb"
            />
          </div>
          <div className="shape-image shape-image-3">
            <img src="/k-youth/images/shapes/shape-04.png" alt="Shape Thumb" />
          </div>
          <div className="shape-image shape-image-4">
            <img
              src="/k-youth/images/shapes/shape-02-01.png"
              alt="Shape Thumb"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default KYouthTestimonialFour;
